document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.similar-vehicle-slider-wrapper');
    if (!wrapper) return;

    const slidesCount = wrapper.querySelectorAll('.swiper-slide').length;

    // Duplikuj slajdy jeśli jest ich mało (dla loop mode)
    if (slidesCount > 1 && slidesCount < 4) {
        const swiperWrapper = wrapper.querySelector('.swiper-wrapper');
        const originalSlides = swiperWrapper.innerHTML;
        swiperWrapper.innerHTML = originalSlides + originalSlides; // Duplikuj wszystkie slajdy
    }

    const swiper = new Swiper('.similar-vehicle-slider-wrapper', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        loopedSlides: 5,
        centeredSlides: false,

        navigation: {
            nextEl: '.slider-arrow-next',
        }
    });

    // Ukryj strzałkę jeśli tylko 1 slajd
    if (slidesCount <= 1) {
        document.querySelector('.slider-arrow-next').style.display = 'none';
    }
});